import { createTheme } from '@mui/material/styles';

export const StyledTheme = {
  colors: {
    curiousBlue: '#389FBA',
    darkGreen: '#1A667A',
    green: '#1A667A',
    lightGray: '#DEE5EC',
    lightGreen: '#3cb4d2',
    purple: '#AF77BE',
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: StyledTheme.colors.green,
      light: StyledTheme.colors.lightGreen,
      dark: StyledTheme.colors.darkGreen,
    },
  },
  typography: {
    fontFamily: ['Outfit', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    fontSize: 18,
    h2: {
      fontSize: 26,
      fontWeight: 700,
      lineHeight: '32px',
    },
    h3: {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: '28px',
    },
    h4: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '28px',
    },
    h5: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '20px',
    },
    h6: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '21.90px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: StyledTheme.colors.curiousBlue,
          '&:hover': {
            background: StyledTheme.colors.darkGreen,
            color: 'white',
          },
        },
        root: {
          borderRadius: 8,
          fontWeight: 700,
          textTransform: 'none',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: StyledTheme.colors.green,
        },
      },
    },
  },
});

export default theme;
